import * as React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { TYPOGRAPHY_SIZE } from 'mm-theme-configuration/dist/consts';
import { LinkButtonDataProps } from '../utils';
import { getStyleBySize } from '../../../../typography/semanticTags/semanticTags.utils';
import { useTheme } from '../../../../theming/useTheme';

export interface LinkButtonThemeProps {
    color: string;
    hoverColor: string;
}

type LinkButtonProps = LinkButtonDataProps & LinkButtonThemeProps;

const createStyle = (color: string, hoverColor: string) => StyleSheet.create({
  button: {
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
    textAlign: 'start',
    color,
    ':hover': {
      color: hoverColor,
    },
    ':active': {
      color,
    },
    ':visited': {
      color,
    },
    ':focus': {
      outline: 'none',
    },
  },
});

export const LinkButton: React.FunctionComponent<LinkButtonProps> = props => {
  const { text, onClick, color, hoverColor } = props;
  const { fontSizesStyles } = useTheme();
  /* eslint-disable-next-line no-new-func */
  const onClickFunction = new Function(onClick);
  const style = createStyle(color, hoverColor);
  const fontStyles = getStyleBySize(fontSizesStyles, { fontSizeLarge: TYPOGRAPHY_SIZE.NORMAL, fontSizeMedium: TYPOGRAPHY_SIZE.NORMAL, fontSizeSmall: TYPOGRAPHY_SIZE.NORMAL });
  return (
    <button type="button" onClick={() => onClickFunction()} className={css(style.button, fontStyles)}>
      {text}
    </button>
  );
};
